// extracted by mini-css-extract-plugin
export var errorIcon = "_kq-1";
export var nameLogo = "_kq-0";